import { SVGProps } from 'react'

export const Gift = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1553_9654)">
        <path
          d="M46.5 10.0013H41.71C42.192 9.04853 42.4616 8.00246 42.5 6.93534C42.4306 5.04885 41.6231 3.26508 40.2514 1.96816C38.8796 0.67124 37.0534 -0.0350683 35.166 0.00134087C32.9179 0.0981705 30.7382 0.803654 28.8597 2.04249C26.9812 3.28132 25.4744 5.00701 24.5 7.03534C23.536 5.01268 22.0407 3.28989 20.1737 2.051C18.3067 0.812114 16.1383 0.103667 13.9 0.00134087C13.824 0.00134087 13.748 0.00134087 13.672 0.00134087C11.8116 0.00432021 10.0248 0.7285 8.68729 2.02163C7.34978 3.31475 6.56574 5.07609 6.5 6.93534V7.06734C6.53902 8.08843 6.79755 9.08913 7.258 10.0013H2.5C1.96957 10.0013 1.46086 10.2121 1.08579 10.5871C0.710714 10.9622 0.5 11.4709 0.5 12.0013L0.5 18.0013C0.5 18.5318 0.710714 19.0405 1.08579 19.4156C1.46086 19.7906 1.96957 20.0013 2.5 20.0013H46.5C47.0304 20.0013 47.5391 19.7906 47.9142 19.4156C48.2893 19.0405 48.5 18.5318 48.5 18.0013V12.0013C48.5 11.4709 48.2893 10.9622 47.9142 10.5871C47.5391 10.2121 47.0304 10.0013 46.5 10.0013ZM35.228 4.00134C36.0449 3.98015 36.8389 4.27227 37.4473 4.81782C38.0557 5.36336 38.4323 6.12098 38.5 6.93534C38.4717 7.75398 38.1281 8.53001 37.5411 9.10134C36.9541 9.67268 36.1691 9.99512 35.35 10.0013H27.456C28.7 7.48334 31.174 4.00134 35.228 4.00134ZM10.5 7.00134C10.5512 6.18292 10.9146 5.41539 11.5153 4.85715C12.116 4.29891 12.908 3.99256 13.728 4.00134C17.866 4.01734 20.29 7.46334 21.548 10.0013H13.748C12.9268 10.0075 12.134 9.70086 11.5307 9.14364C10.9275 8.58643 10.5589 7.82046 10.5 7.00134Z"
          fill="#FF7F6B"
        />
        <path
          d="M28.498 24V48H38.498C40.0893 48 41.6155 47.3679 42.7407 46.2426C43.8659 45.1174 44.498 43.5913 44.498 42V24H28.498Z"
          fill="#FF7F6B"
        />
        <path
          d="M20.498 24H4.49805V42C4.49805 43.5913 5.13019 45.1174 6.25541 46.2426C7.38062 47.3679 8.90675 48 10.498 48H20.498V24Z"
          fill="#FF7F6B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1553_9654">
          <rect width="48" height="48" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
